import React, { useState, useEffect, useCallback, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useLoading } from "../../../../../context/LoadingContext";
import DataTable from "../../../../Requirement/components/common/ReusableTable";
import SearchFilter from "../../../../Requirement/components/common/SearchFilter";
import dayjs from "dayjs";
import { Switch, Tooltip } from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import {
  fetchData,
  searchfetchQueries,
} from "../../../../Requirement/services/RequirementServices";
import AlertModal from "../../../../Requirement/components/common/AlerModel";
import RFQForm from "../../../../buyer/frqOffers/components/RFQForm";
import { Modal, Paper, Box, Typography, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const TradeRfqModal = ({
  open,
  onClose,
  buyerInfo,
  activeUser,
  selectedTradeRFQ,
  setSelectedTradeRFQ,
  onResponse,
}) => {
  const navigate = useNavigate();
  const { setLoading } = useLoading();
  const [rfqList, setRfqList] = useState([]);
  const [rowStart, setRowStart] = useState(0);
  const [pageSize, setPageSize] = useState(5);
  const [totalItems, setTotalItems] = useState(0);
  const [allProductMaster, setAllProductMaster] = useState([]);
  const [productList, setProductList] = useState([]);
  const [productGradeList, setProductGradeList] = useState([]);
  const [searchValues, setSearchValues] = useState({
    requirementNumber: "",
    searchProduct: "",
    searchProductGrade: "",
    searchQuantityRange: "",
  });
  const [selectedRFQ, setSelectedRFQ] = useState(null);

  const quantityOptions = [
    { value: "", label: "Select Range" },
    { value: "50-100", label: "50-100 MT" },
    { value: "100-200", label: "100-200 MT" },
    { value: "200-500", label: "200-500 MT" },
    { value: "Above-500", label: "Above 500 MT" },
  ];

  const loadAllProducts = useCallback(async () => {
    setLoading(true);
    try {
     
        const [allProducts] = await Promise.all([
          searchfetchQueries({
            target: "listProducts",
            userOrder: "ProductID",
            rowStart: 0,
            pageSize: 1000,
          }),
        ]);
        setAllProductMaster(allProducts);
        const distinctProducts = Array.from(
          new Map(
            allProducts
              .filter(p => p.Status === 'ACTIVE') // ✅ Only include active products
              .map(p => [p.ProductName, p])
          ).values()
        );
        setProductList(distinctProducts);
     
    } catch (error) {
      console.error("Error loading products: ", error);
      setAllProductMaster([]);
    } finally {
      setLoading(false);
    }
  }, [setLoading]);

 
const loadProductGrades = useCallback(
    async (productName) => {
      setLoading(true);
      try {
        
        const matchingProducts = allProductMaster.filter(
          (p) => p.ProductName === productName
        );
        setProductGradeList(matchingProducts);
      } catch (error) {
        console.error("Error loading product grades: ", error);
      } finally {
        setLoading(false);
      }
    },
    [setLoading, allProductMaster]
  );

  const handlePageChange = (page) => {
    const newRowStart = (page - 1) * pageSize;
    setRowStart(newRowStart);
    searchRFQs(searchValues, newRowStart);
  };

  const handleRowClick = (row, event) => {
    console.log("row@@", row);
    setSelectedRFQ(row);
  };

  const sendTrueToParent = () => {
    console.log("child sendTrueParent");
    onResponse(true); // Sends true to parent via callback
  };

  const handleSearch = (searchValues) => {
    setRowStart(0);
    searchRFQs(searchValues, 0);
  };

  const searchRFQs = useCallback(
    async (searchValue, newRowStart = rowStart) => {
      setLoading(true);
      try {
        let quantityFilter = {};
        if (searchValue.searchQuantityRange) {
          if (searchValue.searchQuantityRange === "Above-500") {
            quantityFilter = { QuantityGTE: 500 };
          } else {
            const [min, max] = searchValue.searchQuantityRange
              .split("-")
              .map((val) => parseFloat(val));
            quantityFilter = { QuantityGTE: min, QuantityLTE: max };
          }
        }

        const today = new Date().toISOString().split("T")[0];
        let productId = "";
        if (searchValue.searchProduct && searchValue.searchProductGrade) {
          const product = allProductMaster.find(
            (p) =>
              p.ProductName === searchValue.searchProduct &&
              p.Grade === searchValue.searchProductGrade
          );
          if (product) {
            productId = product.ProductID;
            console.log("product##", product.ProductID);
          } else {
            console.warn(
              `No product found for ProductName: ${searchValue.searchProduct}, Grade: ${searchValue.searchProductGrade}`
            );
          }
        }

        const body = {
          target: "listRequirements",
          userOrder: "RequirementsID",
          rowStart: newRowStart,
          pageSize: pageSize,
          filterTerms: {
            CategoryType: "rfq",
            GPEmailID: activeUser,
          },
        };
        const response = await fetchData(body);

        const modifiedItems = (response.items || response).map((item) => ({
          ...item,
          id: item.RequirementsID,
        }));

        setRfqList(modifiedItems);
        setTotalItems(response.total || 0);
      } catch (error) {
        console.error("Error loading RFQs: ", error);
        setRfqList([]);
        setTotalItems(0);
      } finally {
        setLoading(false);
      }
    },
    [pageSize, rowStart, setLoading, activeUser, allProductMaster]
  );

  const currentPage = Math.floor(rowStart / pageSize) + 1;

  const fields = [
    {
      name: "requirementNumber",
      label: "RFQ Number",
      type: "text",
      onChange: (value) =>
        setSearchValues((prev) => ({ ...prev, requirementNumber: value })),
      value: searchValues.requirementNumber,
    },
    {
      name: "searchProduct",
      label: "Product",
      type: "dropdown",
      options: productList.map((item) => ({
        value: item.ProductName,
        label: item.ProductName,
      })),
      value: searchValues.searchProduct,
      onChange: (value) => {
        setSearchValues((prev) => ({ ...prev, searchProduct: value }));
        loadProductGrades(value);
      },
    },
    {
      name: "searchProductGrade",
      label: "Product Grade",
      type: "dropdown",
      options: productGradeList.map((item) => ({
        value: item.Grade,
        label: item.Grade,
      })),
      value: searchValues.searchProductGrade,
      onChange: (value) => {
        setSearchValues((prev) => ({ ...prev, searchProductGrade: value }));
      },
    },
    {
      name: "searchQuantityRange",
      label: "Quantity Range (MT)",
      type: "dropdown",
      options: quantityOptions,
      value: searchValues.searchQuantityRange,
      onChange: (value) => {
        setSearchValues((prev) => ({ ...prev, searchQuantityRange: value }));
        searchRFQs({ ...searchValues, searchQuantityRange: value }, 0);
      },
    },
  ];

  const columns = [
    { id: "RequirementNumber", numeric: false, label: "RFQ No." },
    {
      id: "Product",
      numeric: false,
      label: "Product",
      renderCell: (row) => {
        const pn = allProductMaster.find(
          (item) => item.ProductID === row.ProductID
        );
        return pn ? pn.ProductName : "";
      },
    },
    {
      id: "Grade",
      numeric: false,
      label: "Grade",
      renderCell: (row) => {
        const pn = allProductMaster.find(
          (item) => item.ProductID === row.ProductID
        );
        return pn ? pn.Grade : "";
      },
    },
    { id: "Quantity", numeric: true, label: "Quantity(MT)" },
    { id: "OriginCountry", numeric: false, label: "Origin" },
    {
      id: "DeliveryLocation",
      numeric: false,
      label: "Destination",
      renderCell: (row) => {
        let res = row.DeliveryLocation.split("~");
        if (Array.isArray(res)) {
          return res[0];
        }
        return "";
      },
    },
    {
      id: "ShipmentPeriod",
      numeric: false,
      label: "Shipment Period",
      renderCell: (row) => {
        let dpFrom = row.DeliveryPeriodFrom
          ? dayjs(row.DeliveryPeriodFrom).format("DD-MM-YYYY")
          : "";
        let dpTill = row.DeliveryPeriodTill
          ? dayjs(row.DeliveryPeriodTill).format("DD-MM-YYYY")
          : "";
        return dpFrom !== "" && dpTill !== "" ? dpFrom + " to " + dpTill : "";
      },
    },
    {
      id: "DeliveryPort",
      numeric: false,
      label: "Delivery Port",
      renderCell: (row) => {
        let res = row.DeliveryLocation.split("~");
        if (Array.isArray(res) && res.length > 0) {
          return res[1];
        }
        return "";
      },
    },
    { id: "Incoterm", numeric: false, label: "Incoterms" },
    {
      id: "ProductPackaging",
      numeric: false,
      label: "Packaging",
      renderCell: (row) => {
        const jsonLike = row.ProductPackaging.replace(/{|}/g, "")
          .split(",")
          .map((part) => part.split("="))
          .reduce((obj, [key, value]) => {
            obj[key.trim()] = value ? value.trim() : "";
            return obj;
          }, {});
        return jsonLike.item;
      },
    },
    {
      id: "RequirementDate",
      numeric: false,
      label: "Created",
      renderCell: (row) =>
        row.RequirementDate
          ? dayjs(row.RequirementDate).format("DD-MM-YYYY")
          : "",
    },
    {
      id: "ValidUntil",
      numeric: false,
      label: "Expires",
      renderCell: (row) =>
        row.ValidUntil ? dayjs(row.ValidUntil).format("DD-MM-YYYY") : "",
    },
    {
      id: "action",
      numeric: false,
      label: "Action",
      renderCell: (row) => (
        <div
          style={{
            display: "flex",
            gap: "2px",
            alignItems: "center",
            margin: 0,
            padding: 0,
          }}
        >
          <Tooltip title="Proceed with RFQ">
            <IconButton
              sx={{ color: "#de6b14", width: "20px", height: "20px" }}
              onClick={() => {
                setSelectedTradeRFQ(row); // Set the selected row data
                sendTrueToParent();
                onClose(); // Close the modal
              }}
            >
              <ArrowForwardIcon />
            </IconButton>
          </Tooltip>
        </div>
      ),
    },
  ];

  const selectedRows = rfqList ? [rfqList.RequirementsID || rfqList.id] : [];

  useEffect(() => {
    loadAllProducts();
  }, [loadAllProducts]);

  useEffect(() => {
    if (activeUser && allProductMaster.length > 0) {
      searchRFQs(searchValues);
    }
  }, [rowStart, pageSize, activeUser, searchRFQs, allProductMaster]);

  return (
    <Modal open={open} onClose={onClose}>
      <Paper
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "90%",
          maxHeight: "80vh",
          bgcolor: "background.paper",
          boxShadow: 24,
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            p: 2,
            position: "sticky",
            top: 0,
            bgcolor: "background.paper",
            zIndex: 1,
            borderBottom: "1px solid #e0e0e0",
          }}
        >
          <Typography variant="h6">Trade RFQs</Typography>
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Box>
        <Box
          sx={{
            flex: 1,
            overflowY: "auto",
            p: 2,
          }}
        >
          <div className="search-filter row">
            <SearchFilter fields={fields} onSearch={handleSearch} />
          </div>
          <DataTable
            columns={columns}
            data={rfqList}
            total={totalItems}
            title="RFQ Information"
            rowsPerPage={pageSize}
            onPageChange={handlePageChange}
            currentPage={currentPage}
            onRowClick={handleRowClick}
            selectedRows={selectedRows}
          />
          {selectedRFQ && (
            <RFQForm
              formMode="view"
              setFormMode={true}
              selectedRFQ={selectedRFQ}
              setIsFormVisible={true}
              allProductMaster={allProductMaster}
              btnCancel={false}
              btnAddFinanceRfq={false}
              btnHistory={false}
            />
          )}
        </Box>
      </Paper>
    </Modal>
  );
};

export default TradeRfqModal;
